module.exports = __webpack_public_path__ + "static/media/1353.28f8b5e9.jpg";